const newsletterData = [
    
    {
        title: "PRATIRAV, OCTOBER - DECEMBER, 2025 EDITION",
        description: "We present the October-December, 2025 edition of our Quarterly Newsletter 'Pratirav'. A glance at the newsletter would let you know all the initiatives undertaken by us and the progress made in this duration.",
        link: "/assets/pdf/pratirav/PRATIRAV- October - December 2025.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Oct_Dec_2025.jpeg"
    },
    {
        title: "PRATIRAV, JULY - SEPTEMBER, 2025 EDITION",
        description: "We present the July-September, 2025 edition of our Quarterly Newsletter 'Pratirav'. A glance at the newsletter would let you know all the initiatives undertaken by us and the progress made in this duration.",
        link: "/assets/pdf/pratirav/PRATIRAV- July-September 2025.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Jul_Sep_2025.jpeg"
    },
    {
        title: "PRATIRAV, APRIL-JUNE, 2025 EDITION",
        description: "We present the April-June, 2025 edition of our Quarterly Newsletter 'Pratirav'. A glance at the newsletter would let you know all the initiatives undertaken by us and the progress made in this duration.",
        link: "/assets/pdf/pratirav/Pratirav_Apr_Jun_2025.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Apr_Jun_2025.jpeg"
    },
    {
        title: "PRATIRAV, JANUARY-MARCH, 2025 EDITION",
        description: "We present the January-March, 2025 edition of our Quarterly Newsletter 'Pratirav'. A glance at the newsletter would let you know all the initiatives undertaken by us and the progress made in this duration.",
        link: "/assets/pdf/pratirav/Pratirav_Jan_Mar_2025.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Jan_Mar_2025.jpeg"
    },
    {
        title: "PRATIRAV, OCTOBER-DECEMBER, 2024 EDITION",
        description: "We present the October-December, 2024 edition of our Quarterly Newsletter 'Pratirav'. A glance at the newsletter would let you know all the initiatives undertaken by us and the progress made in this duration.",
        link: "/assets/pdf/pratirav/Pratirav_Oct_Dec_2024.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Oct_Dec_2024.png"
    },
    {
        title: "PRATIRAV, JULY-SEPTEMBER, 2024 EDITION",
        description: "We present the July-September, 2024 edition of our Quarterly Newsletter 'Pratirav'. A glance at the newsletter would let you know all the initiatives undertaken by us and the progress made in this duration.",
        link: "/assets/pdf/pratirav/Pratirav Jul-Sep 2024.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Jul_Sep_2024.png"
    },
    {
        title: "PRATIRAV, APRIL-JUNE, 2024 EDITION",
        description: "We present the April-June, 2024 edition of our Quarterly Newsletter 'Pratirav'. A glance at the newsletter would let you know all the initiatives undertaken by us and the progress made in this duration.",
        link: "/assets/pdf/pratirav/Pratirav Apr-Jun 2024.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Apr_Jun_2024.png"
    },
    {
        title: "PRATIRAV, JANUARY-MARCH, 2024 EDITION",
        description: "We present the January-March, 2024 edition of our Quarterly Newsletter 'Pratirav'. A glance at the newsletter would let you know all the initiatives undertaken by us and the progress made in this duration.",
        link: "/assets/pdf/Pratirav/Pratirav Jan-Mar 2024.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Jan_Mar_2024.png"
    },
    {
        title: "PRATIRAV, OCTOBER-DECEMBER, 2023 EDITION",
        description: "We present the October-December, 2023 edition of our Quarterly Newsletter 'Pratirav'. A glance at the newsletter would let you know all the initiatives undertaken by us and the progress made in this duration.",
        link: "/assets/pdf/Pratirav/Pratirav Oct-Dec 2023.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Oct_Dec_2023.png"
    },
    {
        title: "PRATIRAV, JANUARY-MARCH, 2022 EDITION",
        description: "We present the January-March, 2022 edition of our Quarterly Newsletter 'Pratirav'. A glance at the newsletter would let you know all the initiatives undertaken by us and the progress made in this duration.",
        link: "/assets/pdf/Pratirav/Pratirav jan-march 2022.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Jan_March_2022.png"
    },
    {
        title: "PRATIRAV, OCTOBER-DECEMBER, 2021 EDITION",
        description: "We present the October-December, 2021 edition of our Quarterly Newsletter 'Pratirav'. A glance at the newsletter would let you know all the initiatives undertaken by us and the progress made in this duration.",
        link: "/assets/pdf/Pratirav/Pratirav Oct-Dec 2021.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Oct_Dec_2021.jpeg"
    },
    {
        title: "PRATIRAV, JULY-SEPTEMBER, 2021 EDITION",
        description: "We present the JULY-SEPTEMBER, 2021 edition of our Quarterly Newsletter 'Pratirav'. A glance at the newsletter would let you know all the initiatives undertaken by us and the progress made in this duration.",
        link: "/assets/pdf/Pratirav/Pratirav July to September 2021.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Jul_Sep_2021.jpg"
    },
    {
        title: "PRATIRAV, APRIL-JUNE,2021 EDITION",
        description: "How important is branding for an NGO? How can we prevent children from getting bored in the lockdown? Can we become SuperHeroes as welL? These and many more interesting topics are covered in this edition of Pratirav.",
        link: "/assets/pdf/Pratirav/April-June-2021.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Apr_Jun_2021.jpg"
    },
    {
        title: "PRATIRAV, JANUARY-MARCH, 2021 EDITION",
        description: "Have you wished for guidance while in a dilemma about possible career options? Living in the 21st century, do you think gender equality should still be a question or the norm? Are you brimming with ideas to tackle social problems and waiting for competitions to pitch others? This edition of Pratirav contains our take on these.",
        link: "/assets/pdf/Pratirav/January-March-2021.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Jan_March_2021.png"
    },
    {
        title: "PRATIRAV, OCTOBER-DECEMBER, 2020 EDITION",
        description: "How can your small contribution result in a significant change? How is GYWS helping youth across the country in replicating our learning? Find out in the following edition of Pratirav!",
        link: "/assets/pdf/Pratirav/October-December-2020.pdf",
        imageUrl: "/assets/pratirav/Pratirav_Oct_Dec_2020.jpg"
    },
]

export default newsletterData;